import { Divider, Heading, HStack, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { AddressJSON } from '../../../entities/Address';
import { formatAddress } from '../../../utils/addresses';
import { InteractiveMap } from '../../InteractiveMap';

interface Props {
  address: Pick<AddressJSON, 'street' | 'city' | 'country' | 'postalCode' | 'lat' | 'long'> & { additionalInformation?: string, description?: string };
}

export function ExperienceMap({ address }: Props) {
  const { t } = useTranslation('experience', { keyPrefix: 'details.map' });

  if (address.lat === null || address.long === null) {
    return null;
  }

  return (
    <>
      <Divider />

      <VStack w="100%" spacing={5} alignItems="flex-start">
        <HStack justifyContent="space-between" w="100%">
          <Heading>{t('title')}</Heading>

          <Text>{formatAddress(address)}</Text>
        </HStack>

        <InteractiveMap lat={address.lat} long={address.long} />

        { address.description && <Text fontSize={14}>{address.description}</Text> }
      </VStack>
    </>
  );
}